import { createBroadcastEvent } from '@h5s/util-broadcast';

/**
 * Evento inviato periodicamente da una tab attiva come "heartbeat" per segnalare la sua presenza alle altre tab.
 */
export const TAB_ACTIVE_EVENT = createBroadcastEvent('TAB_ACTIVE_EVENT');
